// extracted by mini-css-extract-plugin
export var body = "index-module--body--Gda2r";
export var buttonContainer = "index-module--buttonContainer--eGQhr";
export var container = "index-module--container--rohYD";
export var details = "index-module--details--A0ROM";
export var heroImage = "index-module--heroImage--wn7mN";
export var invertedColorScheme = "index-module--invertedColorScheme--LxsVX";
export var joinUsButton = "index-module--joinUsButton--PfhKb";
export var label = "index-module--label--dqr5N";
export var mobileBody = "index-module--mobileBody---4+05";
export var mobileHeader = "index-module--mobileHeader--VB5qT";
export var mobileOnly = "index-module--mobileOnly--yJnTL";
export var nonmobile = "index-module--nonmobile---dt6M";
export var os1Body = "index-module--os1Body--GhlXY";
export var os1Title = "index-module--os1Title--crvKj";
export var os2Body = "index-module--os2Body--LhOBa";
export var os2Title = "index-module--os2Title--+2ZRP";
export var osTitle = "index-module--osTitle--Dxh9m";
export var subtitle = "index-module--subtitle--mvm4B";
export var title = "index-module--title--0pc27";